import { API_V2 } from "@/config/api";
import { Messaging } from "@/types/models/Messaging";
import apiRequest from "./api";

export const routes = {
  get: `${API_V2}/messaging/main`,
  update: `${API_V2}/messaging/main`,
};

export const updateMessaging = (input: Partial<Messaging>) =>
  apiRequest<Messaging>(routes.update, {
    method: "POST",
    data: input,
  });
